export { createPosthogWebAdapter } from './lib/posthog-web.adapter'
export type { PosthogWebConfig } from './lib/posthog-web.adapter'
